<sh-box id="service-metrics-box-1" style="flex-grow:0;" background="surface" layout="vertical" elevation="none" style="height: 100%">

  <sh-box-header id="service-metrics-box-header-2" slot="header" padding-bottom="0">
    <sh-icon id="service-metrics-icon-kpi" icon="kpi" size="s" style="margin-left: -2px; margin-right: 4px; cursor: help;" (click)="openHelp('Service Metrics')"></sh-icon>
    <sh-text id="service-metrics-text-4" size="title-1" style="cursor: help;" (click)="openHelp('Service Metrics')">{{ 'serviceMetrics.widget.title' | transloco }}</sh-text>
    <sh-dropdown id="service-metrics-dropdown-5" no-border condensed style="max-width: 120px;" [attr.value]="(selectedRange === 7 ? 'serviceMetrics.widget.range.last7Days' : selectedRange === 14 ? 'serviceMetrics.widget.range.last14Days' : 'serviceMetrics.widget.range.last30Days') | transloco">
      <sh-menu-item id="service-metrics-menu-item-last-7-days" (click)="changeRange(7)" [attr.label]="'serviceMetrics.widget.range.last7Days' | transloco" [active]="selectedRange === 7"></sh-menu-item>
      <sh-menu-item id="service-metrics-menu-item-last-14-days" (click)="changeRange(14)" [attr.label]="'serviceMetrics.widget.range.last14Days' | transloco" [active]="selectedRange === 14"></sh-menu-item>
      <sh-menu-item id="service-metrics-menu-item-last-30-days" (click)="changeRange(30)" [attr.label]="'serviceMetrics.widget.range.last30Days' | transloco" [active]="selectedRange === 30"></sh-menu-item>
    </sh-dropdown>
    <!-- <sh-icon id="service-metrics-icon-information" icon="information" size="s" button [attr.aria-label]="'Information Service Metrics'"></sh-icon> -->

  </sh-box-header>


  <sh-box-section id="service-metrics-box-section-10" style="height: 100%">

    @if (isLoading) {
      <div
        style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
        <sh-spinner id="service-metrics-spinner-11" size="s"></sh-spinner>
      </div>
    }


    @if (!isLoading && servicemetrics) {
      <div style="display: flex; flex-direction: column; gap: 4px;">
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (servicemetrics["cdi"]?.current <= servicemetrics["cdi"]?.benchmark) {
              <sh-icon id="service-metrics-icon-success"
              icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;" (click)="openHelp('CDI')"></sh-icon>
            }
            @if (servicemetrics["cdi"]?.current > servicemetrics["cdi"]?.benchmark) {
              <sh-icon id="service-metrics-icon-warning"
              icon="warning" size="xs" color="var(--warning-yellow)" style="cursor: help;" (click)="openHelp('CDI')"></sh-icon>
            }
            <sh-text id="service-metrics-text-14" [ngClass]="'custom-info'"  style="cursor: help;" (click)="openHelp('CDI')">{{ 'serviceMetrics.widget.cdi' | transloco }}</sh-text>
          </div>
          <div style="flex: 1 1 50px; height: 25px;">
            <canvas baseChart type="bar" class="barChart" [data]="chartConfigs['cdi']?.data"
              [options]="chartConfigs['cdi']?.options">
            </canvas>
          </div>
          <div style="flex: 0 0 50%; display: flex; justify-content: flex-end;">
            @if (servicemetrics['cdi']) {
              <div [ngClass]="'custom-tag'">
                {{servicemetrics["cdi"]?.current}} ({{ 'serviceMetrics.widget.fleet' | transloco }} {{servicemetrics["cdi"]?.benchmark}})
              </div>
            }
          </div>
        </div>
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (servicemetrics["ci"]?.current <= servicemetrics["ci"]?.benchmark) {
              <sh-icon id="service-metrics-icon-success" icon="success"
              size="xs" color="var(--success-icon-color)" style="cursor: help;" (click)="openHelp('CI')"></sh-icon>
            }
            @if (servicemetrics["ci"]?.current > servicemetrics["ci"]?.benchmark) {
              <sh-icon id="service-metrics-icon-warning" icon="warning"
              size="xs" color="var(--warning-yellow)" style="cursor: help;" (click)="openHelp('CI')"></sh-icon>
            }
            <sh-text id="service-metrics-text-17" [ngClass]="'custom-info'"  style="cursor: help;" (click)="openHelp('CI')">{{ 'serviceMetrics.widget.ci' | transloco }}</sh-text>
          </div>
          <div style="flex: 1 1 50px; height: 25px;">
            <canvas baseChart type="bar" class="barChart" [data]="chartConfigs['ci']?.data"
              [options]="chartConfigs['ci']?.options">
            </canvas>
          </div>
          <div style="flex: 0 0 50%; display: flex; justify-content: flex-end;">
            @if (servicemetrics['ci']) {
              <div [ngClass]="'custom-tag'">
                {{servicemetrics["ci"]?.current}} ({{ 'serviceMetrics.widget.fleet' | transloco }} {{servicemetrics["ci"]?.benchmark}})
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (isError) {
      <sh-empty-state id="service-metrics-empty-state-error-retrieving-data" [attr.label]="'serviceMetrics.widget.error' | transloco" icon="error" icon-color="#ebebe"></sh-empty-state>
    }

    @if (isEmpty) {
      <sh-empty-state id="service-metrics-empty-state-no-data-found" [attr.label]="'serviceMetrics.widget.empty' | transloco" icon="information"
      icon-color="#ebebe"></sh-empty-state>
    }

    <!-- <sh-empty-state id="service-metrics-empty-state-select-a-serial-number-fi" *ngIf="!isLoading && !servicemetrics && !isError && !isEmpty"
    label="Select a Serial Number first to see System Information." icon="search"
  icon-color="#ebebe"></sh-empty-state> -->

</sh-box-section>
<!-- <sh-box-footer id="service-metrics-box-footer-21" *ngIf="!isLoading && servicemetrics" slot="footer" padding-top="0" padding-bottom="1rem">
<sh-button id="service-metrics-button-details" (click)="onMaximize(null)" [icon]="checkWidgetIcon()" icon-position="right" icon-size="s"
label="Details" layout="compact" color="secondary" size="s"></sh-button>
</sh-box-footer> -->

</sh-box>